import { render, staticRenderFns } from "./DefaultCurrencySymbol.vue?vue&type=template&id=d90f6ca6&scoped=true&"
import script from "./DefaultCurrencySymbol.vue?vue&type=script&lang=js&"
export * from "./DefaultCurrencySymbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90f6ca6",
  null
  
)

export default component.exports